// ================================
// SIDEBAR REGISTRY
// ================================
// Permet aux modules d'enregistrer leur composant sidebar (building, source, user)
// sans que le Core ne dépende des modules.

import type { Component } from "vue"

const registry = new Map<string, Component>()

/**
 * Enregistre un composant sidebar pour une clé donnée.
 * @param key - Clé du contexte ('building' | 'source' | 'user' | ...)
 * @param component - Composant Vue de la sidebar
 */
export function registerSidebar(key: string, component: Component): void {
    registry.set(key, component)
}

/**
 * Récupère le composant sidebar pour une clé.
 * @param key - Clé du contexte
 * @returns Le composant ou undefined
 */
export function getSidebar(key: string): Component | undefined {
    return registry.get(key)
}
